import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
// import logger from 'redux-logger';
import rootReducer from './reducers';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Persist config
const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['appLoaderReducer'], // it should reset on page load
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Middleware
const middleware = [thunk];

// Enable Redux DevTools only in development
const composeEnhancers =
  process.env.NODE_ENV === 'development' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

// Store
const store = createStore(
  persistedReducer, // use persistedReducer here
  composeEnhancers(applyMiddleware(...middleware))
);

// Persistor
export const persistor = persistStore(store);

export default store;
